module.exports = __webpack_public_path__ + "img/logo25.137bbbb5.svg";